import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import PropertyMortgageAppResource
    from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyMortgageAppResource";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";
import cloneDeep from "lodash/cloneDeep";
import forEach from "lodash/forEach";

class MortgageBalanceAppResource extends AppResource {

    selfClone() {
        const resourceClass = Engine.appResourceClass(this._resourceType)
        let instance = new resourceClass({
            attributes: this.attributes
        }, this._fetched)
        instance.uuid = this.uuid;
        instance._dirty = {}
        instance._errors = null
        instance._fetched = true
        instance._original = cloneDeep(this.attributes)
        forEach(this.relations, (relation, relationName) => {
            if (instance._original === null) {
                instance._original = {}
            }
            instance.setRelation(relationName, relation)
            instance._original[relationName] = cloneDeep(instance.get(relationName))
        })

        return instance;
    }

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'mortgage-balance';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'mortgages/balances';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'propertyMortgageUuid',
            'balance',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            mortgage: PropertyMortgageAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            mortgage: 'property_mortgage_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            propertyMortgageUuid: {
                type: 'string',
            },

            balance: {
                numericality: {
                    greaterThanOrEqualTo: 0,
                },
                presence: true,
            },
        };
    }

}

export default MortgageBalanceAppResource;
